var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "reminder",
    d: "M10,20A10,10,0,0,1,2.929,2.929,10,10,0,1,1,17.071,17.071,9.935,9.935,0,0,1,10,20ZM8.931,14.185a1.533,1.533,0,0,0,1.481,1.467,1.5,1.5,0,0,0,1.453-1.467ZM10.4,3.913A1.033,1.033,0,0,0,9.372,4.951a1.03,1.03,0,0,1-.509.892C7.749,6.49,7.492,7.87,7.242,9.2c-.264,1.413-.514,2.749-1.735,3.147v.855H15.29v-.855c-1.221-.4-1.471-1.733-1.735-3.146-.25-1.334-.508-2.714-1.622-3.362a1.03,1.03,0,0,1-.509-.891A1.033,1.033,0,0,0,10.4,3.913Zm0,1.467a.489.489,0,1,1,.489-.489A.49.49,0,0,1,10.4,5.38Z",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderIcon);
export default __webpack_public_path__ + "static/media/reminder-icon.94bbc116.svg";
export { ForwardRef as ReactComponent };